export const loginSession = (KCToken) => {
	const { KC_JWT } = window;
	// Set cookie
	if (!KC_JWT) {
		window.KC_JWT = KCToken;
		localStorage.setItem('KC_JWT', KCToken)
	}
};

export const logoutSession = () => {
	delete window.KC_JWT;
	localStorage.removeItem('KC_JWT');
	localStorage.removeItem('loadingAdminPage');
	localStorage.removeItem('loggedCountry');
	sessionStorage.removeItem('site_id');
};
